export default {
    BASE_URL: '/crm/rule',
    api: [
      {
        name: 'dictList',
        desc: '查询字典表',
        method: 'GET',
        path: '/dict/list'
      },
      {
        name: 'certificateList',
        desc: '获取证书类型',
        method: 'GET',
        path: '/certificate/list'
      },
      {
        name: 'feeList',
        desc: '获取缴费标准',
        method: 'GET',
        path: '/fee/list'
      },
      {
        name: 'update',
        desc: '更新数据',
        method: 'POST',
        path: '/update'
      },
    ]
  }
  


// WEBPACK FOOTER //
// ./src/api/param/index.js